import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import useStyles from './ImageHotSpot.styles';
import { Button, Tooltip } from '@mui/material';
const RenderHotSpot = ({ content, x, y, classes, mobileImage }) => {
    const [open, setOpen] = useState(false);
    useEffect(() => {
        if (!open) {
            setOpen(true);
        }
    }, [open]);
    return (_jsx(Tooltip, { open: open, title: _jsx(_Fragment, { children: content }), arrow: true, placement: "top", classes: classes, children: _jsx(Button, { className: classes.hotspot, style: {
                left: `${x}%`,
                top: `${y}%`,
            } }) }));
};
const ImageHotSpot = (props) => {
    const { hotspots, mobileImage } = props;
    const { classes } = useStyles();
    const RenderAnchorTag = useCallback((props) => {
        return (_jsx("a", { href: props.link, target: "_blank", className: classes.link, rel: "noopener noreferrer", children: props.label }));
    }, [classes]);
    const hotspotsResult = useMemo(() => hotspots.map((hotspot) => ({
        x: Number((hotspot.points.x * 100).toFixed(4)),
        y: Number((hotspot.points.y * 100).toFixed(4)),
        content: _jsx(RenderAnchorTag, { label: hotspot.selector, link: hotspot.target }),
    })), [RenderAnchorTag, hotspots]);
    return (_jsx("div", { className: classes.hotspotContainer, children: hotspotsResult.map((hotspot) => (_jsx(RenderHotSpot, { content: hotspot.content, x: hotspot.x, y: hotspot.y, classes: { hotspot: classes.hotspot, tooltip: classes.tooltip, popper: classes.popper }, mobileImage: mobileImage }, `${hotspot.x}-${hotspot.y}`))) }));
};
export default ImageHotSpot;
